export type PublicEntryLike = {
  slug?: string | null;
  _metadata?: { title?: unknown } | null;
};

/**
 * Coage para texto só o que tem forma textual honesta. Objeto e array viram "[object Object]"
 * no `String()`, e isso chegaria ao lead como se fosse o nome do item.
 */
const asText = (value: unknown): string | undefined => {
  if (typeof value === "string") return value;
  if (typeof value === "number") return Number.isFinite(value) ? String(value) : undefined;
  if (typeof value === "bigint") return String(value);

  return undefined;
};

/**
 * Título de exibição de uma entry do CMS: o valor do campo marcado como Título, que o
 * cms-api já resolve em `_metadata.title` (com fallback para o slug quando a coleção não tem
 * campo Título). O fallback local cobre respostas pedidas sem `metadata=true`.
 *
 * Genérico de propósito — qualquer bloco que precise nomear uma entry deve usar isto em vez
 * de assumir um campo específico como `name`, que só existe em algumas coleções.
 */
export const resolveEntryTitle = ({
  entry,
}: {
  entry?: PublicEntryLike | null;
}): string | undefined => {
  const title = asText(entry?._metadata?.title);

  if (title != null && title.trim() !== "") {
    return title;
  }

  const slug = entry?.slug;

  return typeof slug === "string" && slug.trim() !== "" ? slug : undefined;
};
